import { defineStore } from 'pinia';
import getMetricsPublisher from '../util/katalMetricsPublisher';

export const TOUR_STORAGE_KEY = 'vendorCentral_navigationRedesign_state';
export const REDESIGN_TOUR_STEPS = {
    TOUR_START: '0',
    STEP_1_NAV_MENU: '1',
    STEP_2_HOW_TO_FAVORITE: '2',
    STEP_3_MANAGE_FAVORITES: '3',
    STEP_4_SWITCHER: '4',
    STEP_5_MESSAGES_SETTINGS_AND_MORE: '5',
    STEP_6_END_MESSAGE: '6',
    TOUR_FINISHED: 'finished',
};
const DEFER_TOUR_PREFIX = 'defer:';
const ONE_WEEK_MS = 7 * 24 * 60 * 60 * 1000;

const initMetricPublisher = () => {
    return getMetricsPublisher().newChildActionPublisherForMethod('RedesignTour');
};

const initFromLocalStorage = () => {
    const storageItem = window.localStorage.getItem(TOUR_STORAGE_KEY);
    if (storageItem === REDESIGN_TOUR_STEPS.TOUR_FINISHED) {
        return REDESIGN_TOUR_STEPS.TOUR_FINISHED;
    } else if (storageItem !== null && storageItem.startsWith(DEFER_TOUR_PREFIX)) {
        const deferDate = Date.parse(storageItem.slice(DEFER_TOUR_PREFIX.length));
        if (deferDate + ONE_WEEK_MS > Date.now()) {
            return REDESIGN_TOUR_STEPS.TOUR_FINISHED;
        }
    }
    return REDESIGN_TOUR_STEPS.TOUR_START;
};

export const useNavRedesignTourStore = defineStore('navRedesignTourStore', {
    state: () => ({
        tourStep: initFromLocalStorage(),
        redesignTourMetricsPublisher: initMetricPublisher(),
        tourMenuItemTop: null,
        tourMenuItemLeft: null,
    }),
    actions: {
        setTourStep(step) {
            this.tourStep = step;
            if (step === REDESIGN_TOUR_STEPS.TOUR_FINISHED) {
                window.localStorage.setItem(TOUR_STORAGE_KEY, REDESIGN_TOUR_STEPS.TOUR_FINISHED);
            }
            this.tourMenuItemTop = null;
            this.tourMenuItemLeft = null;
        },
        setTourNavItemPosition(top, left) {
            this.tourMenuItemTop = top;
            this.tourMenuItemLeft = left;
        },
        deferTour() {
            this.tourStep = REDESIGN_TOUR_STEPS.TOUR_FINISHED;
            window.localStorage.setItem(TOUR_STORAGE_KEY, DEFER_TOUR_PREFIX + new Date().toISOString());
        },
    },
});
